import { render, staticRenderFns } from "./ReglementaireLink.vue?vue&type=template&id=3faabdc6&"
import script from "./ReglementaireLink.vue?vue&type=script&lang=js&"
export * from "./ReglementaireLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports